import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import { getStatisticHeader } from "src/helpers/statistic-list-item";
import { setSummaryStatistics } from "src/redux";
import { capitalizeFirstLetter } from "src/utils/methods";

export const ToolbarListTableSummaryByProvider = (props) => {
  const { provider, campaignId } = props;

  const {
    reportReducer: { campaigns, summaryStatistics: summaryStatisticsFR },
  } = useSelector((state) => state);

  const { publicationsSummary } = campaigns[campaignId] || {};
  const summaryStatistics = summaryStatisticsFR[campaignId];

  const dispatch = useDispatch();

  const toggleFieldVisibility = (name, checked) => {
    let newValue = summaryStatistics[provider];

    if (!checked) {
      newValue = [...newValue, name];
    } else {
      newValue = newValue.filter((item) => item !== name);
    }

    dispatch(setSummaryStatistics(campaignId, provider, newValue));
  };

  return publicationsSummary[provider].summary.map((item) => {
    const checked = summaryStatistics[provider].includes(item.name);

    return (
      <div className="toolbar-list__list-item">
        <CustomCheckbox
          id={`${provider}-${item.name}-table-summary`}
          checked={checked}
          onChange={() => toggleFieldVisibility(item.name, checked)}
        />
        {capitalizeFirstLetter(getStatisticHeader(item.name))}
      </div>
    );
  });
};
